<script>
import LogNavBar from '@/components/Log/LogNavBar.vue';
import LogQueriedNavBar from '@/components/Log/LogQueriedNavBar.vue';
import {
  VIEW_GROK_TAB_KEY,
  VIEW_SAVED_SEARCHES_TAB_KEY
} from '@/components/Log/log.constants';

export default {
  components: {
    LogNavBar,
    LogQueriedNavBar
  },
  computed: {
    showLogNavbar() {
      return (
        this.$route.query.currView !== VIEW_GROK_TAB_KEY &&
        this.$route.query.currView !== VIEW_SAVED_SEARCHES_TAB_KEY
      );
    }
  },
  data() {
    return {
      viewQueriedNav: false
    };
  },
  watch: {
    '$route.query.queryExec': {
      immediate: true,
      handler(newValue) {
        this.viewQueriedNav = newValue?.length > 0 ? true : false;
      }
    }
  }
};
</script>

<template>
  <div>
    <LogQueriedNavBar v-if="viewQueriedNav" />
    <LogNavBar v-else-if="showLogNavbar" />
  </div>
</template>

<style lang="scss" scoped></style>
